import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { connect } from "react-redux";
import formikEnhancer from "./enhancer/FormikEnhancer";
import { compose } from "redux";
import NavigationActions from "redux/navigation/actions";
import {
  addTermsAndConditions,
  editTermsAndConditions,
  getTermsAndConditions
} from "services/termsAndConditions";

function TermsAndConditions(props) {
  const { success, error } = NavigationActions;
  const {
    handleSubmit,
    // handleChange,
    // handleBlur,
    values,
    setFieldValue,
    errors,
    // setValues,
    isValid,
    touched,
    submitCount,
    token
  } = props;

  const [id, setId] = useState("");
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <div style={{ marginTop: "5px" }}>
          <span className={props.class ? props.class : "error-msg"}>
            {errors[field1]}
          </span>
        </div>
      );
    } else {
      return <span />;
    }
  };

  const getTermsdata = async () => {
    await getTermsAndConditions(token).then(res => {
      if (res.success) {
        setFieldValue("conditions", res.data.conditions);
        setId(res.data._id);
      }
    });
  };

  const handleSubmitTermsAndConditions = async e => {
    // e.preventDefault();
    handleSubmit();
    console.log("isValid", isValid, errors);

    if (isValid) {
      id
        ? editTermsAndConditions(token, id, values).then(data => {
            if (data.success) {
              success(data.message);
              getTermsdata();
            } else {
              error(data.message);
            }
            setLoading(false);
          })
        : addTermsAndConditions(token, values).then(data => {
            if (data.success) {
              success(data.message);
              getTermsdata();
            } else {
              error(data.message);
            }
            setLoading(false);
          });
    }
  };

  useEffect(() => {
    getTermsdata();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      TermsAndConditions
      <div className="row ma-0">
        <div className="col-12 col-xl-8 col-lg-12 col-md-12 col-sm-12 ptb-15">
          <ReactQuill
            name="conditions"
            id="conditions"
            value={values?.conditions}
            theme={"snow"}
            placeholder={"Enter the Terms & Conditions Here... "}
            modules={TermsAndConditions.modules}
            formats={TermsAndConditions.formats}
            bounds={".app"}
            // onBlur={handleBlur}
            onChange={(content, delta, source, editor) => {
              if (editor.getLength() <= 1) {
                setFieldValue("conditions", "");
              } else {
                setFieldValue("conditions", content);
              }
            }}
          />
          <Error field="conditions" />
        </div>

        <div className="col-12">
          <button
            type="submit"
            className="c-primary btn btn-secondary"
            disabled={values?.conditions === ""}
            onClick={() => handleSubmitTermsAndConditions()}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

TermsAndConditions.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote", "link"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ]
  ],
  clipboard: {
    matchVisual: false
  }
};

TermsAndConditions.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link"
];

const mapStateToProps = state => {
  // console.log(state);
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  formikEnhancer,
  connect(mapStateToProps)
)(TermsAndConditions);
